export const UPDATE_TRACKING_SESSION_ID = 'UPDATE_TRACKING_SESSION_ID'

export function trackingSessionIdReducer (state = null, action) {
    switch (action.type){
        case UPDATE_TRACKING_SESSION_ID:
            return action.payload
        default: return state
    }
}